import { forwardRef } from 'react';
import { Button, ButtonProps, ButtonVariant } from '../../forms/button/button';
import { Link, LinkProps } from '../link/link';

export type LinkButtonProps = ButtonProps &
  LinkProps & { variant?: ButtonVariant };

/**
 * This component can be either uses with a `to` or a `href` prop
 * When using a "href" prop, the prop "isExternal" should be set to true
 * When using a "to" prop, the prop "isExternal" is not needed
 */
export const LinkButton = forwardRef<typeof Link, LinkButtonProps>(
  function (props, ref) {
    return (
      <Button
        as={Link}
        ref={ref}
        {...props}
        onClick={(e): void =>
          props.isDisabled || props.disabled
            ? e.preventDefault()
            : props.onClick?.(e)
        }
      />
    );
  }
);
